import React, { Component } from 'react';
import Content from '../sections/Faq/Content';

class Faq extends Component {
    render() {
        return (
            <Content/>
        );
    }
}

export default Faq;